import React from 'react';
import * as R from 'ramda';

import { Labeled, TextField } from 'react-admin';
import { Grid } from '@material-ui/core';

import { SalaryField } from 'resources/students/fields';
import { NiceTextField } from 'resources/common';

const BackToJobFields = ({ student }) => {
  return (
    <Grid container>
      <Grid item xs={12} lg={2}>
        <Labeled label="Company">
          <TextField
            record={student}
            source="career_services.outcome.company"
          />
        </Labeled>
      </Grid>
      <Grid item xs={12} lg={2}>
        <Labeled label="Job Title">
          <NiceTextField
            record={student}
            source="career_services.outcome.job_title"
          />
        </Labeled>
      </Grid>
      <Grid item xs={12} lg={3}>
        <Labeled label="Salary">
          <SalaryField
            amount={R.path(
              ['career_services', 'outcome', 'salary', 'amount'],
              student
            )}
            currency={R.path(
              ['career_services', 'outcome', 'salary', 'currency'],
              student
            )}
            type={R.path(
              ['career_services', 'outcome', 'salary', 'salary_type'],
              student
            )}
          />
        </Labeled>
      </Grid>
    </Grid>
  );
};

export default BackToJobFields;
